import { normalizeBirthday } from '~~/app/utils/accountEditPayload'

/** Płeć w postaci czytelnej dla partnerów analitycznych; PrestaShop trzyma id_gender. */
export type IdentityGender = 'male' | 'female'

/** Wycinek odpowiedzi GET /api/store/account/info, z którego budujemy tożsamość. */
export interface AccountIdentitySource {
  id?: number
  email?: string
  firstname?: string
  lastname?: string
  id_gender?: number
  birthday?: string | null
  newsletter?: boolean
}

export interface AccountIdentity {
  id: number
  email?: string
  firstName?: string
  lastName?: string
  newsletter: boolean
  /** RRRR-MM-DD; pominięta, gdy PrestaShop oddaje sentinel '0000-00-00'. */
  birthday?: string
  /** Pominięta przy id_gender = 0 („nie podano") — nie zgadujemy płci. */
  gender?: IdentityGender
}

/** id_gender PrestaShop: 1 = mężczyzna, 2 = kobieta, 0/brak = nieokreślona. */
export function toIdentityGender(idGender: unknown): IdentityGender | undefined {
  if (idGender === 1) return 'male'
  if (idGender === 2) return 'female'
  return undefined
}

/**
 * Jedno mapowanie profilu z backendu na tożsamość dla warstwy danych i authStore.
 *
 * Wspólne dla obu ścieżek ogłaszania `user_data`: hydracji/logowania (useAuth →
 * authStore → syncIdentity) i zapisu „Moje dane" (profile.vue →
 * trackAccountUpdate). Bez tego obiekt `user` różniłby się między ścieżkami —
 * partner (Segmentify) widziałby pola pojawiające się i znikające.
 *
 * Zwraca undefined dla odpowiedzi bez `id` (gość / 401), bo tożsamość gościa
 * ogłaszamy osobnym sygnałem (`user: null`).
 */
export function mapAccountIdentity(
  info: AccountIdentitySource | null | undefined,
): AccountIdentity | undefined {
  const id = typeof info?.id === 'number' ? info.id : 0
  if (!id) {
    return undefined
  }

  return {
    id,
    email: info?.email || undefined,
    firstName: info?.firstname || undefined,
    lastName: info?.lastname || undefined,
    newsletter: Boolean(info?.newsletter),
    birthday: normalizeBirthday(String(info?.birthday ?? '')),
    gender: toIdentityGender(info?.id_gender),
  }
}
